export enum PackageStatusDef { 
  Failed = -1, 
  Pending, 
  Requested,
  Creating,
  Created,
  Ready,
  Downloaded
}